import React, { useState } from 'react';

function StatusBadge({ ok }) {
  return (
    <span className={`badge ${ok ? 'bg-success' : 'bg-danger'}`}>
      {ok ? 'Ready' : 'Error'}
    </span>
  );
}

function Counter() {
  const [count, setCount] = useState(0);
  return (
    <div className="d-flex align-items-center gap-2">
      <button
        type="button"
        className="btn btn-outline-primary btn-sm"
        onClick={() => setCount((c) => c - 1)}
      >
        −
      </button>
      <span className="fw-bold">{count}</span>
      <button
        type="button"
        className="btn btn-outline-primary btn-sm"
        onClick={() => setCount((c) => c + 1)}
      >
        +
      </button>
    </div>
  );
}

export default function ReactTestPage() {
  return (
    <div className="react-test-page">
      <div className="card mb-3">
        <div className="card-body">
          <h5 className="card-title d-flex align-items-center gap-2">
            React status
            <StatusBadge ok={true} />
          </h5>
          <p className="card-text mb-0 text-muted">
            If you see this card and the counter below, React + webpack + Bootstrap are working.
          </p>
        </div>
      </div>

      <div className="card">
        <div className="card-body">
          <h5 className="card-title">Interactive counter</h5>
          <p className="card-text text-muted small mb-2">State and event handlers work when this updates.</p>
          <Counter />
        </div>
      </div>
    </div>
  );
}
